import { createReducer } from 'redux-act'
import {setLoading} from '../actions/loading'

const DEFAULT_STATE = {
    isLoading: false,
}
export default createReducer(
    {
        [setLoading]: (state, payload) => {
            state.isLoading = payload;
            return { ...state }
        }        
    },
    DEFAULT_STATE
);
